<template>
  <v-main>
    <Contacts />
  </v-main>
</template>

<script>
import Contacts from '@/components/contacts'
export default {
  name: 'view-contacts',
  components: { Contacts }
}
</script>
<style scoped>
</style>
